<template>
  <ItemDialog ref="dialogRef" imageType="loader" :initialOpen="false">
    <template v-slot:content-area>
      <h2>予約をキャンセルしています</h2>
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCancelLoading",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>